function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("title", null, "\u7535\u8BDD");

var _ref3 =
/*#__PURE__*/
React.createElement("desc", null, "Created with Sketch.");

var _ref4 =
/*#__PURE__*/
React.createElement("defs", null);

var _ref5 =
/*#__PURE__*/
React.createElement("g", {
  id: "Page-1",
  stroke: "none",
  strokeWidth: 1,
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u6211\\u4EEC",
  transform: "translate(-1126.000000, -312.000000)",
  fill: "#1B1464",
  fillRule: "nonzero"
}, React.createElement("g", {
  id: "\\u8054\\u7CFB\\u65B9\\u5F0F",
  transform: "translate(1126.000000, 229.000000)"
}, React.createElement("path", {
  d: "M19.2090147,103.523733 C17.9046845,104.845221 13.0305888,103.575238 8.22515692,98.7869333 C3.40253551,93.9815014 2.16686918,89.1074057 3.50551556,87.8030755 C4.63823326,86.6703578 6.02838537,84.6795463 8.08786067,87.2710486 C10.147336,89.8625508 9.15191452,90.5661902 7.95053298,91.7332555 C7.12675543,92.539875 8.8601639,94.5993503 10.6278572,96.384233 C12.429898,98.1519263 14.4722152,99.8853033 15.2788347,99.0615258 C16.4630581,97.8773338 17.1838556,96.8819438 19.7238835,98.9242295 C22.3153858,101.018052 20.341701,102.425363 19.2090147,103.523733 Z",
  id: "Shape"
}))));

var SvgTelephone = function SvgTelephone(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTelephone, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/telephone.b4b869bc.svg";
export { ForwardRef as ReactComponent };